import $ from 'jquery';

export class ProjectService {

    static SYSTEM_PROJECT_ID = 9999999;
    
    constructor(component) {
        this.component = component;
    }

    loadProjects() {
        return new Promise((resolve, reject) => {
            try {
                $.get("/api/v1/projects", res => {
                    res = res == null? [] : res;
                    resolve(res);
                })
                .catch(error => {
                    reject(error);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
}